<template>
  <ankh-list :show-btn-group="false" :show-search-form="false">
    <template #tab-row>
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in comps" :key="item.name" :label="$t(item.label)" :name="item.name">
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #table="{height}">
      <keep-alive>
        <component :is="activeName"/>
      </keep-alive>
    </template>
  </ankh-list>
</template>

<script>
import RecipeComments from "@/components/user/RecipeComments";
import DynComments from "@/components/user/DynComments";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserCommentList",
  components: {AnkhList, DynComments, RecipeComments},
  data() {
    return {
      activeName: "DynComments",
      comps: [
        {label: "动态评论", name: "DynComments"},
        {label: "菜谱评论", name: "RecipeComments"}
      ]
    }
  }
}
</script>

<style scoped>

</style>
